import React, { Component } from "react";
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { Col, Row } from "reactstrap";
import { Checkbox, CheckboxGroup } from "@availity/form";

import awardeestore from "../stores/awardeestore";

@observer
export default class AllAcknowledgements extends Component {

	onChangeAcknowledgemnt = (selected, index) => {
        awardeestore.setAcknowledgment(selected, index)
    }

	render() {
		const{allAcknowledgements} = awardeestore;
		const{viewOnly} = this.props;
		return(
			<div className={viewOnly ? "acknowledgementsViewOnly" : ""}>
				{
					allAcknowledgements.map((ack, index) => {
						const labelAck = 
						ack.AcknowledgementCd === "ACK05" ? 
						`${ack.Acknowledgement}<br/>Note: Please print and retain this form, signed by the awardee, on file.`
						: ack.Acknowledgement
						const key = crypto.randomUUID();
						return(
							<Row key={`${key}-${index}`} className="allAcknowledgements">
								<Col>
									<CheckboxGroup value={ack.selected || []} name={`acknowlegmentgroup-${ack.AcknowledgementCd}`} onChange={(e) => this.onChangeAcknowledgemnt(e, index)}>
										<Checkbox
											label={<div dangerouslySetInnerHTML={{__html: labelAck}}/>}
											name={ack.AcknowledgementCd}
											id={ack.AcknowledgementCd}
											groupName={`acknowlegmentgroup-${ack.AcknowledgementCd}`}
											className="label-font no-display"
											value={ack.AcknowledgementCd}
											key={`acknowledgement-${ack.AcknowledgementCd}-Key`}
											disabled={viewOnly}
										/>
									</CheckboxGroup>
								</Col>
							</Row>
						);
					})
				}
			</div>
		);
	}
}

AllAcknowledgements.propTypes = {
	viewOnly: PropTypes.bool
}